// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnerAutocompleteQueryVariables = Types.Exact<{
  filter: Types.TradePartnerFilter;
  page: Types.PageFilter;
}>;


export type TradePartnerAutocompleteQuery = { __typename?: 'Query', tradePartnersPage: { __typename?: 'TradePartnersPage', entities: Array<{ __typename?: 'TradePartner', id: string, name: string }> } };

export type TradePartnerAutocomplete_TradePartnerFragment = { __typename?: 'TradePartner', id: string, name: string };

export const TradePartnerAutocomplete_TradePartnerFragmentDoc = gql`
    fragment TradePartnerAutocomplete_TradePartner on TradePartner {
  ...Named
}
    ${NamedFragmentDoc}`;
export const TradePartnerAutocompleteDocument = gql`
    query TradePartnerAutocomplete($filter: TradePartnerFilter!, $page: PageFilter!) {
  tradePartnersPage(filter: $filter, page: $page) {
    entities {
      ...TradePartnerAutocomplete_TradePartner
    }
  }
}
    ${TradePartnerAutocomplete_TradePartnerFragmentDoc}`;

/**
 * __useTradePartnerAutocompleteQuery__
 *
 * To run a query within a React component, call `useTradePartnerAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerAutocompleteQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTradePartnerAutocompleteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables> & ({ variables: TradePartnerAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>(TradePartnerAutocompleteDocument, options);
      }
export function useTradePartnerAutocompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>(TradePartnerAutocompleteDocument, options);
        }
// @ts-ignore
export function useTradePartnerAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>;
export function useTradePartnerAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerAutocompleteQuery | undefined, TradePartnerAutocompleteQueryVariables>;
export function useTradePartnerAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>(TradePartnerAutocompleteDocument, options);
        }
export type TradePartnerAutocompleteQueryHookResult = ReturnType<typeof useTradePartnerAutocompleteQuery>;
export type TradePartnerAutocompleteLazyQueryHookResult = ReturnType<typeof useTradePartnerAutocompleteLazyQuery>;
export type TradePartnerAutocompleteSuspenseQueryHookResult = ReturnType<typeof useTradePartnerAutocompleteSuspenseQuery>;
export type TradePartnerAutocompleteQueryResult = Apollo.QueryResult<TradePartnerAutocompleteQuery, TradePartnerAutocompleteQueryVariables>;